import React from 'react';
import { Button } from 'antd';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { LeftOutlined } from '@ant-design/icons';
import { navigationSlice } from 'logic/store/navigation/navigation.slice';
import { translate, translationKeys } from 'logic/translations/translations.service';

export const OfferFormGoBackLink = () => {
  const dispatch = useDispatch();
  const handleNavigateBack = useCallback(() => dispatch(navigationSlice.actions.back()), [
    dispatch,
  ]);

  return (
    <Button type="link" onClick={handleNavigateBack}>
      <LeftOutlined />
      {translate(translationKeys.publishOffer.backButton)}
    </Button>
  );
};
